import runTransaction from "../../utils/runTransaction";

import updateArticle from "../articles/updateArticle";

import updateArtifact from "./updateArtifact";

export default function recallArtifact(firebase, { artifact }) {
	return runTransaction(firebase, [artifact.ref, artifact.article.ref], async (transaction, [artifact, article]) => {
		// If this artifact is the default artifact of the article, remove it
		if (article.artifact?.id === artifact.id) {
			await updateArticle(firebase, { ref: article.ref, artifact: null }, { transaction });
		}

		// Remove work and article references from the artifact
		await updateArtifact(firebase, { ref: artifact.ref, work: null, article: null }, { transaction });
	});
}
